import Company from './Company';
import Person from './Person';
import styles from './Styles.style';

class EnrichmentSidebar extends React.Component {
  getResponseFromPerson() {
    const { person } = this.props;

    // Normalize the object we receive
    // from the Person or Response resource
    return Object.assign({}, person, {
      person_name: person.name,
      person_email: person.email,
      person_avatar: person.avatar,
      person_title: person.title,
      person_bio: person.bio,
      person_employment: person.employment,
      person_location: person.location,
    });
  }

  getResponse() {
    const { response, visit, person } = this.props;

    if (response) {
      return response;
    } else if (person) {
      return this.getResponseFromPerson();
    } else if (visit) {
      return visit;
    } else {
      throw new Error('response not provided');
    }
  }

  render() {
    const { classes } = this.props;
    const response = this.getResponse();

    return (
      <div className={classes.root}>
        {response.person_name && (
          <Person response={response} classes={classes} />
        )}

        {response.company_name && (
          <Company response={response} classes={classes} />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(EnrichmentSidebar);
